import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BUSQUEDA_TESORO } from '@env';
import { Storage } from '@ionic/storage';

@Injectable()
export class BusquedaTesoroProvider {

  constructor(public http: HttpClient, private storage: Storage) { }

  async muestraInstrucciones() {
    return await this.storage.get('muestraInstruccionesBusquedaTesoro');
  }

  async actualizaMuestraInstrucciones(status: boolean) {
    await this.storage.set('muestraInstruccionesBusquedaTesoro', status);
  }

  buscaCertamenActivo(area: string): Promise<any> {
    return this.http.get( `${BUSQUEDA_TESORO.ACTIVA}${area}` ).toPromise();
  }

  historial(area: string): Promise<any> {
    return this.http.get( `${BUSQUEDA_TESORO.HISTORIAL}${area}` ).toPromise();
  }

  nivelUsuario(area: string, jugador: string): Promise<any> {
    return this.http.get( `${BUSQUEDA_TESORO.NIVELES_USUARIO}${area}/${jugador}` ).toPromise();
  }

  seleccionaSede(params: { busquedaDelTesoro: string, jugador: string, uuid: string }): Promise<any> {
    return this.http.post( `${BUSQUEDA_TESORO.SELECCIONA_SEDE}`, params ).toPromise();
  }

  obtenPreguntasNivel(area: string, jugador: string): Promise<any> {
    return this.http.get( `${BUSQUEDA_TESORO.OBTEN_PREGUNTAS_NIVEL}${area}/${jugador}` ).toPromise();
  }

  actualizaEstadisticas(avanceId: string, estadisticas: Array<any>): Promise<any> {
    return this.http.post( `${BUSQUEDA_TESORO.ACTUALIZA_ESTADISTICAS}`, { avanceId, estadisticas} ).toPromise();
  }

  buscaTesoro(tesoro: string): Promise<any> {
    return this.http.get( `${BUSQUEDA_TESORO.TESORO}${tesoro}`, ).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/providers/busqueda-tesoro/busqueda-tesoro.ts